export default function Logo({ className = "h-14", imageClassName = "", variant = "default" }: { className?: string, imageClassName?: string, variant?: "default" | "dark" }) {
  const src = variant === "dark" 
    ? "https://vibe.filesafe.space/1774569058151009111/attachments/4e95b9f6-a5cc-44f2-9e1d-fe1284b07bc2.png"
    : "https://vibe.filesafe.space/1774569058151009111/attachments/06738efe-ac88-41a1-aee0-dc89a4d456a7.png";

  return (
    <img 
      src={src}
      alt="Woods Spine and Wellness Logo" 
      width="200"
      height="80"
      fetchPriority="high"
      decoding="async"
      className={`w-auto object-contain shrink-0 ${className} ${imageClassName}`}
    />
  );
}
